import { Component } from '@angular/core';
import { NavController, MenuController } from 'ionic-angular';
import { HomePage } from '../home/home'; 

// ---- COMMON MODULES ---- //
import { Functions } from '../../providers/functions';
import { TranslateService } from '@ngx-translate/core';
import { DataExchanger } from '../../providers/data-exchanger';

@Component({
  selector: 'page-rankings',
  templateUrl: 'rankings.html'
})
export class RankingsPage {
  rankings:any;

  constructor(public functions: Functions, public dataExchanger: DataExchanger, public rubedoSideMenu: MenuController, public translate: TranslateService, public navCtrl: NavController) {
    this.rubedoSideMenu = rubedoSideMenu;
    this.rubedoSideMenu.enable(true, 'rubedoSideMenu');
    this.functions.setSideMenuColorEnabled(true);
  }

  ionViewWillEnter(){
    //before the page in question becomes active
    this.functions.changeShowSidemenuButtonTo(true);

    this.dataExchanger.getRankingsFromServer().then((response)=>{
      this.rankings=response;
    });
  }

  goToMainMenu(){
    this.navCtrl.setRoot(HomePage, {});
  }
}



// WEBPACK FOOTER //
// ./src/pages/rankings/rankings.ts